import React from 'react';
import {
    Box,
    Button, Card, CardContent, CardHeader,
    Chip, List, ListItem, ListItemText,
    Paper, Stack, Typography,
} from "@mui/material";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import {helper} from "../../../utils/helper";
import Constants from "../../../utils/constants";
import './InterventionView.css'
import '../layout/PhotoCarousel.css'
import PhotoCarousel from "../layout/PhotoCarousel";
import BadgeTypeLavage from "../layout/BadgeTypeLavage.js";
import TypologieLavageBadge from "../layout/TypologieLavageBadge.js";
import {ConteneurIcon} from "../../../utils/ui/Icons/ConteneurIcon.js";

export default function InterventionView({intervention, conteneur, patrimoine, onPDFClick, largeDisplay}) {
    const isInaccessible = !intervention?.isAccessible;
    const hasMaintenance = intervention?.isAccessible && intervention?.problemes?.length > 0;
    const hasPhotos = intervention?.photosAvant?.length > 0 && intervention?.photosApres?.length > 0

    const getTotalConteneurs = () => patrimoine?.isUniatprimoine
        ? patrimoine?.nombreDeBacs
        : conteneur?.quantite;

    const getLabelNombreLaves = () => `${intervention?.nombreLaves} / ${getTotalConteneurs()}`;

    return (
        <Stack spacing={3}>
            <Stack direction="row" flexWrap="wrap" spacing={2}>
                <Chip
                    label={`Statut : ${helper.getInterventionStatus(intervention)}`}
                    sx={helper.getInterventionStatusColor(intervention)}
                />
                <Chip label={`Prestation : ${intervention?.prestation}`}/>
                <TypologieLavageBadge typologie={intervention?.typologieLavage} sx={{ml: 1}}/>
                <Chip icon={<ConteneurIcon fontSize={"large"}/>} label={`Lavé(s) : ${getLabelNombreLaves()}`}/>
            </Stack>

            {hasPhotos &&
                <Stack direction="row" spacing={2} alignItems="stretch">
                    <Box flexGrow={1}>
                        <PhotoCarousel
                            photoArray={intervention?.photosAvant}
                            label="Photos avant lavage"
                            headerStyle="carousel-blue"
                            assetsUrl={`${Constants.API_ASSETS_PHOTO_INTERVENTION}/`}
                        />
                    </Box>
                    <Box flexGrow={1}>
                        <PhotoCarousel
                            photoArray={intervention?.photosApres}
                            label="Photos après lavage"
                            headerStyle="carousel-green"
                            assetsUrl={`${Constants.API_ASSETS_PHOTO_INTERVENTION}/`}
                        />
                    </Box>
                </Stack>
            }

            {isInaccessible && (
                <Stack direction="row" spacing={2} alignItems="stretch">
                    <Paper sx={{p: 2, flexShrink: 0}}>
                        <Typography variant="h6" color="error.main" gutterBottom>
                            Lavage impossible
                        </Typography>
                        <List>
                            {intervention?.problemes?.map((p) => (
                                <ListItem key={p.id}><ListItemText primary={`- ${p.libelle}`}/></ListItem>
                            ))}
                        </List>
                    </Paper>
                    <Box flexGrow={1}>
                        <PhotoCarousel
                            photoArray={intervention?.photosInaccessible}
                            label="Photos lavage impossible"
                            headerStyle="carousel-red"
                            assetsUrl={`${Constants.API_ASSETS_PHOTO_INTERVENTION}/`}
                        />
                    </Box>
                </Stack>

            )}


            {hasMaintenance && (
                <Stack direction="row" spacing={2} alignItems="stretch">
                    <Paper sx={{p: 2, flexShrink: 0}}>
                        <Typography variant="h6" color="warning.main" gutterBottom>
                            Maintenance signalée
                        </Typography>
                        <List>
                            {intervention?.problemes?.map((p) => (
                                <ListItem key={p.id}><ListItemText primary={`- ${p.libelle}`}/></ListItem>
                            ))}
                        </List>
                    </Paper>
                    <Box flexGrow={1}>
                        <PhotoCarousel
                            photoArray={intervention?.photosProblem}
                            label="Photos maintenance"
                            headerStyle="carousel-orange"
                            assetsUrl={`${Constants.API_ASSETS_PHOTO_INTERVENTION}/`}
                        />
                    </Box>
                </Stack>
            )}

            {intervention?.observation?.trim() && (
                <Paper sx={{p: 2}}>
                    <Typography variant="h6" gutterBottom>Commentaire</Typography>
                    <Typography variant="body2" sx={{whiteSpace: 'pre-wrap'}}>{intervention.observation}</Typography>
                </Paper>
            )}
        </Stack>
    );
}
